<template>
  <v-dialog v-model="show" persistent :max-width="$vuetify.display.mobile ? `80vw` : `50vw`">
      <v-card class="custom-card">
          <v-card-title class="text-h6 text-center">
              Ez a csapatnév már használatban van, kérem válasszon másikat!
          </v-card-title>
          <v-btn color="rsz500" size="x-large" variant="text" @click="closeDialog">
              Rendben!
          </v-btn>
      </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: `TeamNameTakenDialog`,
  props: {
      showdialog: {
          type: Boolean,
          default: false, // Set the default value to false
      },
  },
  emits: ["dialogChange"],
  data() {
      return {
          show: this.showdialog,
      };
  },
  watch: {
      showdialog(newValue) {
          this.show = newValue;
      },
  },
  methods: {
      closeDialog() {
          this.show = false;
          this.$emit(`dialogChange`, this.show);
      },
  },
});
</script>